'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

require('../styles/BackButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  handleClick: _react2.default.PropTypes.func.isRequired
};

var BackButton = exports.BackButton = function (_BcReactComponent) {
  _inherits(BackButton, _BcReactComponent);

  function BackButton() {
    _classCallCheck(this, BackButton);

    return _possibleConstructorReturn(this, (BackButton.__proto__ || Object.getPrototypeOf(BackButton)).apply(this, arguments));
  }

  _createClass(BackButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _baseButtons.BlueTextButton,
        {
          className: 'cp-user-list-back-button',
          'data-test-id': 'back-button',
          handleClick: this.props.handleClick },
        _react2.default.createElement(
          'div',
          { className: 'back-button-contents' },
          _react2.default.createElement(_baseIcons.Arrows.long.Left, null),
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_mylists' })
        )
      );
    }
  }]);

  return BackButton;
}(_baseBcReactComponent2.default);

BackButton.propTypes = propTypes;

exports.default = BackButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/back-button/components/BackButton.component.js
// module id = 1277
// module chunks = 0